@use "variables" as *;

.description {
  margin-bottom: $spacing-xl;
}

.grid {
  margin-bottom: $spacing-m;
  overflow: auto;
}

.fieldName {
  font-size: $fontSize-m;
  font-weight: bold;
  height: 100%;
  text-align: center;
  padding: $spacing-s;
  word-wrap: anywhere;
}
